const state = {
    parks_list: '',
    park_index:''
};

const mutations = {
    set_parks_list (state,val){
        state.parks_list = val;
    },//设置state中属性的值
    //这个方法就是设置 parks_list 的值
    set_park_index (state,val){
        state.park_index = val;
    }
};

const actions = {};

const getters = {};

export default {
    state,
    mutations,
    actions,
    getters
}
